/** @module csi/view/ToolbarMessage */
define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"csi/view/ToolbarPlugin"
], function(declare,_WidgetBase,ToolbarPlugin) {

	return declare([_WidgetBase,ToolbarPlugin], {
		baseClass: "dijitInline csi-toolbar-message",

		/** @property {string} message - The text to be rendered on the toolbar */
		message: "",

		/**
		 * @override
		 * Set appearance based on action
		 */
		postMixInProperties: function() {
			if(this.defAction) {
				this._mixinActionProperties();
			}

			this.inherited(arguments);
		},

		_setMessageAttr: {node: "domNode", type: "innerText"}
	});
});
